import Button from "components/common/Button/Button";
import Content from "components/Content";
import Header from "components/Header";
import styled from "themes";

export const StyledHeader = styled(Header)`
  position: relative;
`;

export const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-left: 3em;
`;

export const StyledButton = styled(Button)`
  width: 250px;
`;



// WEBPACK FOOTER //
// ./src/screens/Kiosk/Welcome.style.tsx